export default "__VITE_ASSET__JUtbPclM__"